export default __webpack_public_path__ + "static/media/portada.cef03e5f.png";